<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmSpcmCalenderFormData && Object.keys(vmSpcmCalenderFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3" v-if="propActivity">
                  <label for="validationtitle">{{cvTitleLabel}}</label> <span class="primary-color font-size-16">*</span>
                    <input
                      v-model="vmSpcmCalenderFormData.title"
                      placeholder="Enter title"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                <div class="col-md-12 mb-3" v-if="propActivity">
                  <label for="validationdescription">{{cvDescriptionLabel}}</label> <span class="primary-color font-size-16">*</span>
                    <textarea
                      v-model="vmSpcmCalenderFormData.description"
                      type="text"
                      class="form-control textarea"
                      required
                    ></textarea>
                </div>
                <div class="col-12 mb-3" v-if="propActivity">
                    <label for="validationslot_duration">
                      {{cvCounsellorEventCategoryabel}}</label
                    >
                  <select v-model="vmSpcmCalenderFormData.category" class="form-control">
                    <option :value="null" disabled>Choose Category</option>
                    <option :value="null">All</option>
                    <option v-for="(category, index) of spcmCalendarCategory" :key="(index+1)" :value="category.category_name">
                      {{ category.category_name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcounsellor_id">{{cvCounsellorsList}}</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="displayCounsellorName"
                    readonly
                    disabled
                  />
                  <input type="hidden" v-model="vmSpcmCalenderFormData.counsellor_id" />
                </div>
                <div class="col-md-6 mb-3">
                <label for="validationslot_start_ts">{{cvDateLabel}}</label>
                  <datetime
                    type="date"
                    v-model="convertedDateTime"
                    :value="convertedDateTime"
                    input-class="gide_datetime_input"
                    class="datetime-theme-primary col-12 px-0"
                    :format="{ year: 'numeric', month: 'long', day: 'numeric'}"
                    :phrases="{ok: 'Continue', cancel: 'Exit'}"
                    :hour-step="1"
                    :minute-step="5"
                    :week-start="7"
                    use12-hour
                    auto
                    :min-datetime="vmStartDate ? vmStartDate : minStartDate">
                  </datetime>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="validationslot_start_ts">
                      Time</label
                    >
                <datetime
                  type="time"
                  :value="convertedDateTime2"
                  v-model="convertedDateTime2"
                  input-class="form-control"
                  :format="{hour: 'numeric', minute: '2-digit'}"
                  :phrases="{ok: 'Continue', cancel: 'Exit'}"
                  :hour-step="1"
                  :minute-step="5"
                  :week-start="7"
                  use12-hour
                  auto
                  :min-datetime="vmStartDate ? vmStartDate : minStartDate"></datetime>

                </div>
                <div class="col-md-12 mb-3">
                    <label for="validationslot_duration">
                      {{cvSlotDurationLabel}} (in secs)</label
                    >
                    <input
                      v-model="vmSpcmCalenderFormData.slot_duration"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="session_hosting_platform s-heading">Hosting PlatForm</label>
                  <select
                    v-model="vmSpcmCalenderFormData.calendar_hosting_platform"
                    class="form-control"
                    id="session_hosting_platform"
                  >
                    <option
                      v-for="(platform, index) in SPCMSessionHostingPlatForm"
                      :key="index"
                      :value="platform"
                    >
                      {{ platform }}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validation_chooseDate">Meeting Weblink</label>
                  <input
                    v-model="vmSpcmCalenderFormData.calendar_meeting_link"
                    type="text"
                    class="form-control"
                    id="validation_session_weblink"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validation_cc_email">CC Email</label>
                  <input
                    v-model="vmSpcmCalenderFormData.cc_email"
                    type="text"
                    class="form-control"
                    id="validation_cc_email"
                    placeholder="Enter comma-separated email addresses"
                  />
                  <small class="text-muted">* Comma-separated values will be used for reminder emails and Google Calendar</small>
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="spcmCalendarEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { SpcmCalenders } from "../../../FackApi/api/SpcmCalender"
import ApiResponse from "../../../Utils/apiResponse.js"
import { Datetime } from "vue-datetime"
import moment from "moment"
import { SpcmCalendarCategorys } from "../../../FackApi/api/SpcmCalendarCategory.js"
import SPCMSessionHostingPlatForm from "../../../FackApi/json/SPCMSessionHostingPlatForm.json"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"

export default {
  name: "SpcmCalenderEditV1",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propSpcmCalenderId: {
      type: String,
      default: null
    },
    propSpcmCalenderObj: {
      type: Object,
      default: function () {
        return {
          "counsellor_id": "",
          "slot_start_ts": "",
          "slot_duration": "",
          "calendar_hosting_platform": "",
          "calendar_meeting_link": "",
          "session_id": "",
          "cc_email": ""
        }
      }
    },
    propActivity: {
      type: Boolean,
      default: false
    },
    propSessionEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Counsellor's Calendar",
      cvCardSubHeader: "Edit Counsellor's Calendar",
      cvDescriptionLabel: "description",
      cvCounsellorEventCategoryabel: "Category",
      cvTitleLabel: "Title",
      cvSubmitBtn: "Edit",
      cvSlotStartTsLabel: "Time",
      cvCounsellorsList: "counsellor name",
      cvDateLabel: "Date",
      cvSlotDurationLabel: "Duration",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Edit Response",
      cvSelectLabel: "Counselor Name",
      vmSpcmCalenderFormData: {},
      vmStartDate: "",
      minStartDate: "",
      convertedDateTime2: "",
      convertedDateTime: "",
      spcmCalendarCategory: [],
      counsellorObjList: [],
      counsellor_id: {},
      propSpcmCalendarObjCopy: {},
      SPCMSessionHostingPlatForm: SPCMSessionHostingPlatForm
    }
  },
  components: {
    Datetime
  },
  computed: {
    /**
     * Finds the counselor name from the list based on the ID stored in form data
     */
    displayCounsellorName () {
      const id = this.vmSpcmCalenderFormData.counsellor_id
      const counselor = this.counsellorObjList.find(c => c.counsellor_user_id == id)
      return counselor ? counselor.user_name : "Loading..."
    },
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    this.propSpcmCalendarObjCopy = { ...this.propSpcmCalenderObj }
    await this.spcmCounsellorList()
    this.spcmCalendarView()
    await this.SpcmCalendarCategoryList()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSpcmCalenderFormData) {
          if (!this.vmSpcmCalenderFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * spcmCalendarView
     */
    async spcmCalendarView () {
      try {
        if (this.propOpenedInModal && this.propSpcmCalenderObj && Object.keys(this.propSpcmCalenderObj).length > 0 && this.propSpcmCalenderObj.spcm_calendar_id) {
          if (this.propSpcmCalenderObj.slot_start_ts) {
            const date = new Date(this.propSpcmCalenderObj.slot_start_ts * 1000)
            this.convertedDateTime = moment(date.setDate(date.getDate() + 1)).format("YYYY-MM-DD") // Convert Unix timestamp to milliseconds
            this.convertedDateTime2 = moment(new Date(this.propSpcmCalenderObj.slot_start_ts * 1000)).format("HH:mm") // Convert Unix timestamp to milliseconds
          }
          else {
            this.convertedDateTime = null // Convert Unix timestamp to milliseconds
            this.convertedDateTime2 = null // Convert Unix timestamp to milliseconds
          }
          this.vmSpcmCalenderFormData = this.propSpcmCalenderObj
        }
        else {
          let spcmCalendarId = this.$route.params.spcm_calendar_id
          let spcmCalendarViewResp = await SpcmCalenders.spcmCalendarView(this, spcmCalendarId, this.propSpcmCalenderObj.user_id)
          const spcmCalendarObj = spcmCalendarViewResp.resp_data.data
          if (spcmCalendarObj.slot_start_ts) {
            const date = new Date(spcmCalendarObj.slot_start_ts * 1000)
            this.convertedDateTime = moment(date.setDate(date.getDate() + 1)).format("YYYY-MM-DD") // Convert Unix timestamp to milliseconds
            this.convertedDateTime2 = moment(new Date(spcmCalendarObj.slot_start_ts * 1000)).format("HH:mm") // Convert Unix timestamp to milliseconds
          }
          else {
            this.convertedDateTime = null // Convert Unix timestamp to milliseconds
            this.convertedDateTime2 = null // Convert Unix timestamp to milliseconds
          }
          if (spcmCalendarViewResp && spcmCalendarViewResp.resp_status) {
            this.vmSpcmCalenderFormData = spcmCalendarViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarView() and Exception:", err.message)
      }
    },
    /**
     * spcmCalendarEdit
     */
    async spcmCalendarEdit () {
      try {
        const datePart = new Date(this.convertedDateTime)
        const timePart = new Date(this.convertedDateTime2)

        const newTimestamp = moment(new Date(
          datePart.getFullYear(),
          datePart.getMonth(),
          datePart.getDate(),
          timePart.getHours(),
          timePart.getMinutes()
        )).unix()

        // 2. Conditional Update Logic
        // If newTimestamp matches the original prop time, we do NOT update it.
        // Otherwise, we apply the new value.
        if (newTimestamp !== this.propSpcmCalenderObj.slot_start_ts) {
          this.vmSpcmCalenderFormData.slot_start_ts = newTimestamp
          console.log("Time changed. Updating timestamp.")
        }
        else {
          // Ensure we use the exact original timestamp to prevent drift
          this.vmSpcmCalenderFormData.slot_start_ts = this.propSpcmCalenderObj.slot_start_ts
          console.log("Time unchanged. Updating other fields only.")
        }

        // 3. Proceed with API call (Title, Description, and Duration will still be sent)
        this.cvLoadingStatus = true
        let spcmCalendarAddResp = await SpcmCalenders.spcmCalendarEdit(this, this.vmSpcmCalenderFormData)
        await ApiResponse.responseMessageDisplay(this, spcmCalendarAddResp)

        if (spcmCalendarAddResp && !spcmCalendarAddResp.resp_status) {
          this.$emit("emitEditFails", this.propSpcmCalendarObjCopy)
          return false
        }

        if (this.propOpenedInModal) {
          this.$emit("emitCloseSpcmCalenderEditModal", this.vmSpcmCalenderFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCalendarEdit():", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * SpcmCalendarCategory List
     */
    async SpcmCalendarCategoryList () {
      try {
        let SpcmCalendarCategoryListResp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
        if (SpcmCalendarCategoryListResp.resp_status) {
          this.spcmCalendarCategory = SpcmCalendarCategoryListResp.resp_data.data
          this.showLoadMoreBtn = true
        }
        else {
          this.toastMsg = SpcmCalendarCategoryListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryList() and Exception:", err)
      }
    },
    /**
     * setCounsellorListFilters
    */
    async spcmCounsellorList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data
      }
    }
  }
}
</script>
<style>
 textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
